import jQuery from 'jquery';
import Swiper from 'swiper';
import slick from 'slick-carousel';
import { createApp } from "vue/dist/vue.esm-bundler.js"
//import swipebox from 'swipebox';

export default function() {
    // Old code
    window.$ = jQuery;

    if ($('.js-current-dealer').data('id')) {
        window.currentDealer = $('.js-current-dealer').data('id');
        $('a[href*="/financement/"]').each(function () {
            $(this).attr('href', $(this).attr('href') + '#dealer=' + window.currentDealer);
        });
        $('a[href*="/vendre/"]').each(function () {
            $(this).attr('href', $(this).attr('href') + '#dealer=' + window.currentDealer);
        });
    }

    $('.js-concession-info__schedule').click(function () {
        $(this).closest('.c-concession-info').toggleClass('is-schedule-active');
        console.log($(this).closest('.c-concession-info'));
        return false;
    });

    $('.js-cookie-trigger a').click(function () {
        $('.cky-btn-revisit-wrapper.cky-revisit-bottom-left').click();
        return false;
    });

    // add into #menu-footer-extra a new li & a and and event click similar to js-cookie-trigger
    $('.c-footer-links').append('<li><a href="#" class="js-cookie-trigger-alt">Gestion des cookies</a></li>');
    $('.js-cookie-trigger-alt').click(function () {
        $('.cky-btn-revisit-wrapper.cky-revisit-bottom-left').click();
        return false;
    });
    $('.cky-btn-revisit-wrapper').css('visibility', 'hidden');
    

    if (location.hash && location.hash.indexOf('dealer=') > -1) {
        try {
            $('[name="Concessionnaire"]').val(location.hash.replace('#dealer=', ''));
        } catch (e) { }
    }

    $(window).scroll(function () {
        if ($(window).scrollTop() > 135) {
            $('html').addClass('is-sticky-header');
        } else {
            $('html').removeClass('is-sticky-header');
        }
    });

    if (window.innerWidth < 1024) {
        var swiperConcessions = new Swiper('.js-concessions-slider', {
            slidesPerView: 1.1,
            spaceBetween: 10,
            resizeObserver: true,
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            // navigation: {
            //     nextEl: '.js-concessions-slider-next',
            //     prevEl: '.js-concessions-slider-prev',
            // },
            breakpoints: {
                660: {
                    slidesPerView: 2.15,
                    spaceBetween: 30,
                }, 
                992: {
                    // direction: 'vertical',
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            }
        });
    }

    // Map update Class toggling logic
    function updateMap(dataMap, dataPin, elm) {

        // reset maps and pins class
        $('.js-map-wrap').removeClass('is-active');
        $('.js-map-pin').removeClass('is-active');

        // Remove single concession active
        $('.c-concessions-mobile').removeClass('is-active');
        $('.o-section-map').removeClass('is-single-active');
        $('.c-concessions-mobile__item').removeClass('is-active');

        // set map active class
        $('.js-map-wrap-' + dataMap).addClass('is-active');

        // Set pin active IF isn't cluster
        if (dataPin !== '') {
            $('.js-map-wrap-' + dataMap + ' .js-map-pin[data-pin=' + dataPin + ']').addClass('is-active');
            $('.js-map-pin[data-concession="' + $(elm).attr('for') + '"').addClass('is-active');
            $('.js-map-pin[data-concession="' + $(elm).attr('for') + '"').prev().prop("checked", true);
        }

        // Check if region is define, if isn't assign map to region
        var region = elm.data('region');
        if (!region) {
            region = dataMap;
        }
        $('.c-concessions-region .js-map-region.is-active').removeClass('is-active');
        $('.c-concessions-region .js-map-region[data-region="' + region + '"]').addClass('is-active');
    }

    // All single pin click are redirected to left nav for code sanity
    $('.js-concession-button').click(function (e) {
        $('.js-schedule-nav__item[data-table=".js-schedule-table-ventes"]').click();
        // if is desktop
        if ($(window).width() > 1023) {
            if ($(this).hasClass('is-active')) {
                // if already active, reset map and region
                $(this).removeClass('is-active');
                $('.js-map-wrap').removeClass('is-active');
                $('.js-map-pin').removeClass('is-active');
                $('.js-map-wrap-1').addClass('is-active');
                $('.c-concessions-selector__item input').prop("checked", false);
                $('.js-concession-expanded .c-concessions-expanded__item.is-active').removeClass('is-active');
                return false;
            } else {
                // Open new concession
                $('.c-concessions-selector .js-concession-button').removeClass('is-active');
                $(this).addClass('is-active');
                var thisEl = $(this);
                var dataMap = $(this).data('map');
                var dataPin = $(this).data('pin');
                updateMap(dataMap, dataPin, thisEl);

                // active the good concession sidebar (right)
                if ($(this).attr('for') !== null) {
                    // Set single concession active
                    $('.js-concession-expanded .c-concessions-expanded__item.is-active').removeClass('is-active');
                    $('.c-concessions-mobile').addClass('is-active');
                    $('.o-section-map').addClass('is-single-active');
                    $('.js-' + $(this).attr('for')).addClass('is-active');
                }
            }
        }
        return false;
    })

    $('.js-concession-scrollto').click(function (e) {
        $('html, body').animate({
            scrollTop: $('#carte-concession-' + $(this).data('concession')).offset().top - 80
        }, 600);
    })

    // click on single pin
    $('.js-map-pin').click(function () {
        // Remove single concession active
        if ($(this).data('concession') !== null && window.innerWidth > 767) {
            $('.js-concession-button[for="' + $(this).data('concession') + '"]').click();
        }
    })
    // Click on cluster pins
    $('.js-pins-cluster').click(function () {
        if (window.innerWidth > 767){
            var thisEl = $(this);
            var dataMap = $(this).data('map');
            var dataPin = $(this).data('pin');
            updateMap(dataMap, dataPin, thisEl);
        }
    })
    // Update region (left column nav)
    $('.js-map-region').click(function () {
        // var thisEl = $(this);
        // updateMap($(this).data('region'), '', thisEl);
        // $('.c-concessions-selector__item input').prop("checked", false);
        $('.js-map-wrap').removeClass('is-active');
        $('.js-map-pin').removeClass('is-active');
        $('.js-map-wrap-1').addClass('is-active');
        $('.c-concessions-selector__item input').prop("checked", false);
        $('.js-concession-expanded .c-concessions-expanded__item.is-active').removeClass('is-active');
        return false;
    })

    // Click concession image under map
    // $('.js-concession-info__link img').click(function () {
    //     var consId = $(this).parent().data('concession');
    //     $('.js-concession-button[data-concession=' + consId + ']').click();
    //     console.log('.js-concession-button[data-concession=' + consId + ']');
    // });

    $('.js-schedule-nav__item').click(function () {
        $(this).closest('.c-schedule').find('.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        $($(this).data('table')).addClass('is-active');
        return false;
    })

    $('.js-concessions-selector__title').click(function () {
        $(this).parent().toggleClass('is-mobile-active');
    });

    // 2022


    if ($('body').hasClass('single-neuf')) {
        $('.wp-block-button__link').each(function () {

            $(this).addClass('js-show-generic').data('title', $(this).text())
        });
    }
    $(document).on('click', '.js-show-generic', function () {
        $('body').addClass('overlay-active');
        $('.c-overlay-cta-form').hide();
        $('.js-overlay-cta').addClass('is-active');
        $('.js-overlay-title').text($(this).data('title'));
        $('.js-form-title').val($(this).data('title'));
        $('.js-overlay-generic').show();
        return false;
    });

    $('.js-table-tabs-btn').click(function () {
        // Remove state active
        $(this).closest('.c-table-tabs').find('.c-table-tabs-btn.is-active').removeClass('is-active');
        $(this).closest('.c-table-tabs').find('.c-table-tabs-content.is-active').removeClass('is-active');
        // Add state active
        $(this).addClass('is-active');
        $(this).closest('.c-table-tabs').find($(this).data('table-tabs')).addClass('is-active');
        return false;
    });

    $('body').on('click', '.js-remove-filter svg', function () {
        var selector = $(this).parent().data('selector');
        var checkbox = $(selector)[0];
        checkbox.checked = false;
        $(selector).change();
    });

    $(document).on('click', '.js-overlay-close', function () {
        $('body').removeClass('overlay-active');
        $('.js-overlay-cta').removeClass('is-active');
        return false;
    });

    $('.js-overlay-bg').click(function () {
        $('.js-overlay-close').click();
        return false;
    });

    /*$('#menu-main > .menu-item-has-children > a').on('click', function (e) {
        if ($(window).width() > 1023) {
            e.preventDefault();
            $('.c-btn-search.js-btn-search').add('.c-nav-search.js-searchform-wrapper').removeClass('is-active');
            $('#menu-main > .menu-item-has-children > a, #menu-main > .js-nav-showroom > a').not(this).parent().removeClass('-nav-desktop-open');
            $('body').removeClass('is-showroom-hover');
            $('.js-nav-showroom > a').removeClass('is-active');
            $(this).parent().toggleClass('-nav-desktop-open');
            // if any element has class -nav-desktop-open
            if ($('#menu-main > .menu-item-has-children.-nav-desktop-open').length || $('#menu-main > .js-nav-showroom.-nav-desktop-open').length) {
                $('.c-header__desktop-bg').add('html').addClass('-nav-desktop-open');
            } else {
                $('.c-header__desktop-bg').add('html').removeClass('-nav-desktop-open');
            }
        }
    });*/

    // Unsure
    $(document.body).on('click touchend', '#swipebox-slider .current img', function (e) {
        return false;
    }).on('click touchend', '#swipebox-slider .current', function (e) {
        $('#swipebox-close').trigger('click');
    });

    $('.menu > .menu-item-has-children > a').click(function () {
        if ($(window).width() > 1023) return true;
        if ($('.js-sm-visible:visible')) {
            $(this).parent().toggleClass('is-mobile-active');
            return false;
        }
    });

    $('.js-car-overview-btn-scroll').click(function () {
        $('html, body').animate({
            scrollTop: $(".c-section-car-new").offset().top - 100
        }, 1000);
        return false;
    });

    $('body').on('click', '.js-btn-cta', function () {
        $('body').addClass('overlay-active');
        $('.c-overlay-cta-form').hide();
        $('.js-overlay-cta').addClass('is-active');
        $('.js-overlay-title').text($(this).text());
        $('.js-form-title').val($(this).text());
        $('.js-overlay-generic').show();
        return false;
    });


    $('body').on('click', '.js-btn-form', function () {

        return true;
    });

    $('body').on('click', '.js-btn-jobs', function () {
        var infos = $(this).parent().prev();
        var title = infos.find('.c-jobs-list__title').text();
        var concessionnaire = infos.find('.c-jobs-list__dealer').text();
        var concessionnaire_id = infos.find('.c-jobs-list__dealer').data('concessionnaire');
        var responsabilites = infos.find('.c-jobs-list__list').eq(0).html();
        var exigences = infos.find('.c-jobs-list__list').eq(1).html();

        // wp ajax GET get_overlay_template
        $.get('/wp/wp-admin/admin-ajax.php?action=get_overlay_template&concessionnaire=' + concessionnaire_id, function (data) {
            $('.js-overlay-jobs .c-overlay-cta-form__inner.-concession > .o-row > .o-col').html(data);
        });

        // put title in overlay input name poste
        $('.js-overlay-jobs input[name=poste]').val(title);
        $('.js-overlay-jobs .c-overlay-form-jobs__text__title').text(title);
        $('.js-overlay-jobs input[name=Concessionnaire]').val(concessionnaire_id);
        $('.js-overlay-jobs .c-jobs-list__dealer').text(concessionnaire);
        if (responsabilites) {
            $('.js-overlay-jobs .js-responsabilites').html(responsabilites);
            $('.js-overlay-jobs .js-responsabilites').show();
            $('.js-overlay-jobs .c-jobs-list__responsabilities').show();
        } else {
            $('.js-overlay-jobs .js-responsabilites').hide();
            $('.js-overlay-jobs .c-jobs-list__responsabilities').hide();
        }
        if (exigences) {
            $('.js-overlay-jobs .js-exigences').html(exigences);
            $('.js-overlay-jobs .js-exigences').show();
            $('.js-overlay-jobs .c-jobs-list__exigences').show();
        } else {
            $('.js-overlay-jobs .js-exigences').hide();
            $('.js-overlay-jobs .c-jobs-list__exigences').hide();
        }
        $('body').addClass('overlay-active');
        $('.c-overlay-cta-form').hide();
        $('.js-overlay-cta').addClass('is-active');
        $('.js-overlay-jobs').show();
        return false;
    });

    $('body').on('click', '.js-btn-new-car', function () {
        $('body').addClass('overlay-active');
        $('.c-overlay-cta-form').hide();
        $('.js-overlay-cta').addClass('is-active');
        $('.js-overlay-car-new').show();
        if ($('.c-car-overview__card:first-child').html()) {
            $('.js-overlay-car-new_content').html($('.c-car-overview__card:first-child').html());
        }
        else if ($('.c-car-overview-photo:first-child').html()) {
            $('.js-overlay-car-new_content').html($('.c-car-overview-photo:first-child').html());
        }
        else if ($('.js-btn-enlarge[tabindex=0]:first-child').html()) {
            $('.js-overlay-car-new_content').html($('.js-btn-enlarge[tabindex=0]:first-child').html());
        }
        else if ($(".c-picture-slider__item:first-child").html()) {
            $('.js-overlay-car-new_content').html($(".c-picture-slider__item:first-child").html());
        }
        $('.c-overlay-cta-form .o-checkbox').addClass('js-include-taxes-placeholder');
        $('.js-include-taxes-placeholder').attr('id', 'js-include-taxes');
        $('.js-include-taxes-placeholder').attr('name', 'js-include-taxes');
        $('.js-include-taxes-placeholder').next().attr('for', 'js-include-taxes');
        if ($('#price-taxes1').is(':checked')) {
            $('.js-include-taxes-placeholder').prop('checked', true);
        } else {
            $('.js-include-taxes-placeholder').prop('checked', false);
        }
        return false;
    });

    $('body').on('click', '.js-btn-budget', function () {
        $('body').addClass('overlay-active');
        $('.c-overlay-cta-form').hide();
        $('.js-overlay-cta').addClass('is-active');
        $('.js-overlay-budget').show();
        return false;
    });

    $('body').on('click', '.js-include-taxes-placeholder', function () {
        window.vueShowroom.includeTaxes = !!this.checked;
        setTimeout(function () {
            $('.js-overlay-car-new_content').html($('.c-car-overview__card:first-child').html());
            $('.c-overlay-cta-form .o-checkbox').addClass('js-include-taxes-placeholder');
            $('.js-include-taxes-placeholder').attr('id', 'js-include-taxes');
            $('.js-include-taxes-placeholder').attr('name', 'js-include-taxes');
            $('.js-include-taxes-placeholder').next().attr('for', 'js-include-taxes');
            if ($('#price-taxes1').is(':checked')) {
                $('.js-include-taxes-placeholder').prop('checked', true);
            } else {
                $('.js-include-taxes-placeholder').prop('checked', false);
            }
        }, 2);
    });

    if ($('.c-showroom-row-btn').length) {
        var $nav = $('.c-showroom-row-btn');
        var options = [];
        $nav.find('.c-showroom-btn').each(function () {
            options.push('<option value="' + $(this).data('table-tabs') + '" ' + ($(this).hasClass('is-active') ? 'selected' : '') + '>' + $(this).text() + '</option>');
        });
        var html = '<div class="c-mobile-alternative-tabs -form-light"><div class="c-contact-form_item"><label for="" class="c-mobile-alternative-tabs__label"><span class="c-select-arrow-down"></span><div class="c-custom-select-wrapper"><select class="c-custom-select js-mobile-tabs-home">' +
            options.join('') +
            '</select></div></label></div></div>';
        $nav.before(html);
    }


    $('.js-mobile-tabs-home').on('change', function () {
        $('.js-showroom-row').removeClass('is-active');
        $($(this).val()).addClass('is-active');
        return false;
    });

    /*

    $('.js-mobile-tabs').on('change',function() {
         $(this).closest('.c-table-tabs-wrapper').find('.c-table-tabs-content.is-active').removeClass('is-active');
         $(this).closest('.c-table-tabs-wrapper').find($(this).val()).addClass('is-active');
         return false;
    })
    */


    $('.c-text table').wrap('<div class="c-table-overflow"></div>');

    $('.js-home-showroom-btn').click(function () {
        $('.js-home-showroom-btn').removeClass('is-active');
        $(this).addClass('is-active');
        var panelIndex = $(this).index();
        $('.js-showroom-row').removeClass('is-active');
        $('.c-showroom-panels .js-showroom-row:eq(' + panelIndex + ')').addClass('is-active');
        return false;
    });

    $('.js-btn-nav-mobile').click(function () {
        //$(this).toggleClass('is-active');
        $('body').toggleClass('-nav-mobile-open');
        $('body').removeClass('is-showroom-hover');
        return false;
    });

    $('.js-box-hours-btn').click(function () {
        $(this).parent().find('.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        $('.c-box-hours-tables table').hide();
        $($(this).data('target')).show();
        return false;
    });


    $('.js-car-models-list').slick({
        //autoplay:true,
        dots: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '<div class="c-btn-slider-models -prev"><svg class="o-ico -slider"><use xlink:href="/app/themes/nissan/images/sprite.svg?v=0.0.1#arrow-full-left"></use></svg></div>',
        nextArrow: '<div class="c-btn-slider-models -next"><svg class="o-ico -slider"><use xlink:href="/app/themes/nissan/images/sprite.svg?v=0.0.1#arrow-full-right"></use></svg></div>',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
    });

    $('.js-showroom-filter').on('click', function () {
        $('.js-showroom-filter').removeClass('is-active');
        $(this).addClass('is-active');
        if ($(this).data('filter') == 'all') {
            $('.c-nav-showroom-list__item').show();
        }
        else {
            var cat = $(this).data('filter');
            $('.c-nav-showroom-list__item').hide();
            $('.c-nav-showroom-list__item[data-categories*="' + cat + '"]').show();
        }
    });

    $('.c-btn-slide-index.-next').click(function () {
        $('.-next.slick-arrow').click();
    });
    $('.c-btn-slide-index.-prev').click(function () {
        $('.-prev.slick-arrow').click();
    });

    $('.js-slider-clickbuy').slick({
        // autoplaySpeed: 6000,
        // autoplay: true,
        prevArrow: $('.c-slider_supnav_arrow-left'),
        nextArrow: $('.c-slider_supnav_arrow-right'),
        dots: true,
        appendDots: $('.js-dots-arrows'),
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    }).on('beforeChange', function (e, slick, c, n) {
        $('.-test > div').removeClass('is-active');
        $('.-test > div:eq(' + n + ')').addClass('is-active')
    })

    $('.-test > div').on('click', function () {
        var idx = $(this).index();
        $('.js-slider-clickbuy').slick('slickGoTo', idx);
        return false;
    });

    $('.js-slider-home').slick({
        autoplaySpeed: 6000,
        autoplay: true,
        prevArrow: $('.js-dots-arrows-prev'),
        nextArrow: $('.js-dots-arrows-next'),
        dots: true,
        appendDots: $('.js-dots-arrows'),
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    }).on('beforeChange', function () {
        $('.js-slider-home img[loading]').removeAttr('loading')
        var $current = $('.js-slider-home .slick-active')
        if ($current.find('video').length) {
            try {
                $current.find('video').get(0).pause();

            } catch (e) {
                alert('unable to play video')
            }

        }
    }).on('afterChange', function (e, slick, slide) {
        var $current = $('.js-slider-home .slick-active')
        if ($current.find('video').length) {
            try {
                $current.find('video').get(0).play();

            } catch (e) {
                alert('unable to play video')
            }

        }
    });
    setTimeout(function () {
        if (!$('.js-slider-home').length) return;
        var $current = $('.js-slider-home .slick-active');
        if ($current.find('video').length) {
            try {
                $current.find('video').get(0).play();

            } catch (e) {
                alert('unable to play video')
            }

        }
    }, 100);

    var $status = $('.js-slider-index-num');
    var $slickElement = $('.js-car-used-slider');

    $slickElement.slick({
        //autoplay:true,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="c-picture-slider__button -prev"><svg class="o-ico -slider"><use xlink:href="/app/themes/nissan/images/sprite.svg?v=0.0.1#arrow-left"></use></svg></div>',
        nextArrow: '<div class="c-picture-slider__button -next"><svg class="o-ico -slider"><use xlink:href="/app/themes/nissan/images/sprite.svg?v=0.0.1#arrow-right"></use></svg></div>',
        dotsClass: '.c-slide-index',
        customPaging: function (slider, i) {
            //console.log(slider);
            return (i + 1) + '/' + slider.slideCount;
        }
    });

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i);
    });

    $('.js-btn-models-filters').click(function () {
        $('.c-car-models-nav .is-active').removeClass('is-active');
        $(this).addClass('is-active');
        return false;
    });


    //$('.js-swipebox').swipebox();


    $('.js-btn-search').click(function () {
        $('.js-btn-search').toggleClass('is-active');
        $('.js-searchform-wrapper').toggleClass('is-active');
        $('#menu-main > .menu-item-has-children > a, #menu-main > .js-nav-showroom > a').parent().removeClass('-nav-desktop-open');
        if ($('.js-btn-search.is-active').length) {
            $('.c-header__desktop-bg').add('html').addClass('-nav-desktop-open');
        } else {
            $('.c-header__desktop-bg').add('html').removeClass('-nav-desktop-open');
        }
        $('.c-nav-search__input').focus();
        return false;
    });

    //$(".js-salle-expo-mobile").clone().insertAfter(".js-nav-showroom > a");

    /*$('.js-nav-showroom > a, .js-close-nav-showroom').click(function () {
        if ($('.c-nav-showroom-hover-wrapper:visible').length) {
            $('body').toggleClass('is-showroom-hover');
            $('.js-nav-showroom > a').toggleClass('is-active');
            // Volvo Style nav
            if ($(window).width() > 1023) {
                $('#menu-main > .menu-item-has-children > a').not(this).parent().removeClass('-nav-desktop-open');
                $(this).parent().toggleClass('-nav-desktop-open');
                // if any element has class -nav-desktop-open
                if ($('#menu-main > .menu-item-has-children.-nav-desktop-open').length || $('#menu-main > .js-nav-showroom.-nav-desktop-open').length) {
                    $('.c-header__desktop-bg').addClass('-nav-desktop-open');
                } else {
                    $('.c-header__desktop-bg').removeClass('-nav-desktop-open');
                }
            }
            return false;
        } else {
            //
            $('.js-nav-showroom').toggleClass('is-mobile-active');
            return false;
        }
    });*/

    $('body').on('click', '.js-salle-expo-mobile-nav__item', function () {
        $('.js-salle-expo-mobile-nav__item.is-mobile-active').removeClass('is-mobile-active');
        $(this).addClass('is-mobile-active');
        $('.c-salle-expo-mobile__inner .js-showroom-car').hide();
        if ($(this).data('filter') == 'all') {
            $('.c-salle-expo-mobile__inner .js-showroom-car').show();
        } else {
            var cat = $(this).data('filter');
            $('.c-salle-expo-mobile__inner .js-showroom-car[data-categories*="' + cat + '"]').show();
        }
        return false;
    });

    $('.js-buttons-row__item').click(function () {
        if ($(this).hasClass('is-active')) {
            $('.js-buttons-row__item').removeClass('is-active');
        } else {
            $('.js-buttons-row__item').removeClass('is-active');
            $(this).addClass('is-active');
        }
    });

    $('.js-button-expand__close').click(function () {
        $('.js-buttons-row__item').removeClass('is-active');
    });

    $(document).on('click', '.js-button-scroll-prev', function () {
        $('.js-filter-scroll').animate({
            scrollLeft: '-=120'
        }, 300, 'easeOutQuad');
    });
    $(document).on('click', '.js-button-scroll-next', function () {
        $('.js-filter-scroll').animate({
            scrollLeft: '+=120'
        }, 300, 'easeOutQuad');
    });

    $('.js-button-toggle').click(function () {
        $(this).toggleClass('-active');
        return false;
    });

    $('.js-btn-scrolltop').click(function () {
        $("body, html").animate({
            scrollTop: 0
        });
    });

    /*$.datepicker.regional['fr'] = {
        closeText: 'Fermer',
        prevText: '&#x3c;Préc',
        nextText: 'Suiv&#x3e;',
        currentText: 'Aujourd\'hui',
        monthNames: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin',
            'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun',
            'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
        weekHeader: 'Sm',
        dateFormat: 'dd-mm-yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
        //minDate: 0,
        maxDate: '+12M +0D',
        numberOfMonths: 1,
        showButtonPanel: true
    };
    $.datepicker.setDefaults($.datepicker.regional['fr']);
    setTimeout(function () {
        $(".js-datepicker").attr('autocomplete', 'nope').datepicker({ minDate: 0 }).on('keypress', function (e) { e.preventDefault(); });
    }, 1000)*/


    $('.c-nav-showroom-hover-wrapper').on('click', function (e) {
        if ($(e.target).hasClass('c-nav-showroom-hover-wrapper')) {

            $('.js-nav-showroom:first a').click();
        }
    });

    $('.js-accordion-title').click(function () {
        //.log('acc. clicked');
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active').next().slideUp();
        } else {
            $('.js-accordion-title.is-active').removeClass('is-active').next().slideUp();
            that = $(this);
            setTimeout(function () {
                that.addClass('is-active').next().slideDown();
            }, 125);
        }
        return false;
    });

    $('body').keydown(function (e) {
        if ($('body').hasClass('is-showroom-hover') && e.keyCode == 27) {
            $('.js-nav-showroom:first a').click();
        }
    });



    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function setCookie(c_name, c_value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        document.cookie = encodeURIComponent(c_name)
            + "=" + encodeURIComponent(c_value)
            + (!exdays ? "" : "; path=/; expires=" + exdate.toUTCString());
        ;
    }




    function sendAllGA(eventdata) {
        //console.log('Sending',eventdata,ga.getAll().length);
        window.dataLayer = window.dataLayer || []
        dataLayer.push({
            'event': 'formSubmission',
            'formType': eventdata.eventCategory
        });
    }

    $(document).on('submit', '.js-lpdg-form', function () {


        var frm = $(this).get(0);

        if (!frm.checkValidity()) {
            alert('Veuillez compléter tous les champs requis !');
            return false;
        }
        var $div = $('<div class="c-hidden js-extra-form-data" />');
        var additions = {
            "Page actuelle": location.href,
            "Page précédente": document.referrer,
            "lpdgform": "1"
        }
        $.each(additions, function (k, v) {
            var $input = $('<input type="hidden" />');
            $input.attr('name', k);
            $input.attr('value', v);
            $input.appendTo($div);
        });
        $(this).find('.js-extra-form-data').remove();
        $div.appendTo($(this));
        let formData = new FormData($(this)[0]);
        fetch('/', {
            method: "POST",
            credentials: "same-origin",
            body: formData,
        });
        //$.post('/', $(this).serializeArray());
        $(this).get(0).reset();
        $(this).find('.js-form-submit').after('<div class="c-form-success js-form-success"><p>Merci, votre message a été envoyé avec succès.</p></div>');
        if ($(this).hasClass('-no-suc')) {
            $('body').addClass('overlay-active');
            $('.c-overlay-cta-form').hide();
            $('.js-overlay-cta').addClass('is-active');
            $('.js-overlay-confirmation-form').show();
        }
        return false;
    });

    $('.js-btn-enlarge').click(function () {
        var i = $('.js-car-used-slider').slick('slickCurrentSlide');
        $('.js-swipebox:eq(' + i + ')').click();
        return false;
    });



    // Remove the menu background overlay and close all active submenus when the background is clicked
    $('.c-header__desktop-bg').on('click', function (e) {
        $(this).add('html').removeClass('-nav-desktop-open');
        $('#menu-main > .menu-item-has-children').removeClass('-nav-desktop-open');
        $('.c-btn-search.js-btn-search').add('.c-nav-search.js-searchform-wrapper').removeClass('is-active');
        $('body').removeClass('-nav-mobile-open');
    });

    $('.c-info-legal').on('click', function () {
        $(this).toggleClass('is-active');
        $(this).find('.c-info-legal__content').toggleClass('is-active');
        $('.c-info-legal').not(this).removeClass('is-active');
        $('.c-info-legal').not(this).find('.c-info-legal__content').removeClass('is-active');
        return false;
    });

    //Set CSS4 variable for innerHeight
    function setDocHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
    };
    window.addEventListener('resize', function () {
        setDocHeight();
    });
    window.addEventListener('orientationchange', function () {
        setDocHeight();
    });
    setDocHeight();



    $('.js-home-forms-btn').click(function () {
        $('.c-home-forms__forms__wrapper').removeClass('-active');
        $('.c-home-forms__forms__wrapper' + $(this).data('target')).addClass('-active');
        $(this).closest('.c-home-forms__row').find('.c-home-forms__item.-active').removeClass('-active');
        $(this).closest('.c-home-forms__item').addClass('-active');
        return false;
    });

    $('.js-home-forms-arrow').click(function () {
        $('.c-home-forms__forms__wrapper').removeClass('-active');
        $('.c-home-forms__item.-active').removeClass('-active');
        $('.c-home-forms-arrow__wrapper.-active').removeClass('-active');
        $('.c-home-forms__forms__wrapper' + $(this).data('target')).addClass('-active');
        $(this).addClass('-active');
        return false;
    });

    $('.js-home-forms-arrow.-budget').click(function () {
        $(this).closest('.c-home-forms__row').find('.js-home-form-budget').addClass('-active');
        $(this).closest('.c-home-forms__row').find('.js-home-form-budget').find('.c-home-forms-arrow__wrapper').addClass('-active');
        return false;
    });
    $('.js-home-forms-arrow.-echange').click(function () {
        $(this).closest('.c-home-forms__row').find('.js-home-form-echange').addClass('-active');
        $(this).closest('.c-home-forms__row').find('.js-home-form-echange').find('.c-home-forms-arrow__wrapper').addClass('-active');
        return false;
    });
    $('.js-home-forms-arrow.-inventaire').click(function () {
        $(this).closest('.c-home-forms__row').find('.js-home-form-inventaire').addClass('-active');
        $(this).closest('.c-home-forms__row').find('.js-home-form-inventaire').find('.c-home-forms-arrow__wrapper').addClass('-active');
        return false;
    });

    $('.js-service-btn').hover(function () {
        $('.c-service-brands-hover__inner').removeClass('-active');
        $('.c-service-brands__item.-active').removeClass('-active');
        $('.c-service-brands-hover__inner' + $(this).data('target')).addClass('-active');
        $(this).addClass('-active');
        return false;
    });

    $('.js-show-more').click(function () {
        $(this).closest('.c-jobs-list__inner').find('.c-jobs-list__content').toggleClass('-expended');
        return false;
    });



    $('.js-file-input').on('change', function () {
        if ($(this).val()) {
            var fileArr = $(this).val().toString().split('\\');
            $('.js-file-label').text(fileArr[fileArr.length - 1]);

        } else {
            $('.js-file-label').text('Aucun fichier sélectionné');
        }
        return false;
    });

    // Contact toggle

    $('.js-contact-toggle').click(function () {
        $('.c-contact-tabs__item').removeClass('-active');
        $(this).addClass('-active');
        $('.js-contact-form.-active').removeClass('-active');
        $(this).closest('.c-contact-tabs__wrapper').find('.js-contact-form' + $(this).data('target')).addClass('-active');
        return false;
    });

    // Car Overview Legal message
    $('body').on('click', '.js-legal', function () {
        $(this).toggleClass('is-active');
        $('.c-car-overview__legal__text').toggleClass('is-active');
    });

    // Car Overview Tooltips
    $('body').on('click', '.js-tooltip', function () {
        $(this).toggleClass('is-active');
        $('.js-tooltip').not(this).removeClass('is-active');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.js-tooltip').length) {
            $('.js-tooltip').removeClass('is-active');
        }
    });


    if (window.innerWidth < 768) {
        setTimeout(function () {
            $('.js-mobile-accordion__target:not(.is-mobile-active)').slideUp();
            $('.js-mobile-accordion').click(function () {
                if ($(this).hasClass('is-mobile-active')) {
                    $('.js-mobile-accordion').removeClass('is-mobile-active');
                    $('.js-mobile-accordion__target').slideUp();
                    // $('.js-mobile-accordion__target').css('height', '0');
                } else {
                    $('.js-mobile-accordion').removeClass('is-mobile-active');
                    $('.js-mobile-accordion__target').removeClass('is-mobile-active');
                    $('.js-mobile-accordion__target').slideUp();
                    $(this).toggleClass('is-mobile-active').next('.js-mobile-accordion__target').toggleClass('is-mobile-active');
                    $(this).next('.js-mobile-accordion__target').slideDown();
                    return false;
                }
            });
        }, 15);
    }

    // Inner accordion
    setTimeout(function () {
        $('.js-inner-accordion-content:not(.is-active)').slideUp();
        $('.js-inner-accordion-content.is-active').slideDown();
        $('.js-inner-accordion').click(function () {
            if ($(this).hasClass('is-active')) {
                $('.js-inner-accordionn').removeClass('is-active');
                $(this).removeClass('is-active');
                $('.js-inner-accordion-content').removeClass('is-active');
                $('.js-inner-accordion-content').slideUp();
            } else {
                $('.js-inner-accordion').removeClass('is-active');
                $('.js-inner-accordion-content').removeClass('is-active');
                $('.js-inner-accordion-content').slideUp();
                $(this).toggleClass('is-active').next('.js-inner-accordion-content').toggleClass('is-active');
                $(this).next('.js-inner-accordion-content').slideDown();
                return false;
            }
        });
    }, 15);

    // Anchor accordion
    if (window.innerWidth < 768) {
        setTimeout(function () {
            $('.js-open-accordion-trigger').click(function () {
                if ($('.js-open-accordion').hasClass('is-mobile-active')) {

                } else {
                    $('.js-open-accordion').addClass('is-mobile-active');
                    $('.js-open-accordion-target').addClass('is-mobile-active');
                    // $('.js-open-accordion-target').css('height', $('.js-open-accordion-target').prop('scrollHeight') + 'px');
                    $('.js-open-accordion-target').slideDown();
                }
            });
        }, 15);
    }


    // Home slider
    const homeSwiper = window.homeslider = new Swiper('.js-home-slider', {
        grabCursor: true,
        speed: 400,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        on: {
            slideChange: function () {

                $('.js-home-slider img[loading]').removeAttr('loading')
                $('.js-home-slider video').each(function () {
                    if ($(this).closest('.swiper-slide-active').length) {
                        try {
                            $(this).get(0).pause();
                        } catch (e) { }
                    } else {
                        try {
                            $(this).get(0).play();
                        } catch (e) { }
                    }
                });
            },
            init: function () {
                setTimeout(function () {
                    if ($(this).closest('.swiper-slide-active video').length) {
                        try {
                            $(this).closest('.swiper-slide-active video').get(0).play();
                        } catch (e) { }
                    }
                }, 100);
            }
        }
    });

    $('body').on('click','.js-show-legal', function(){
        $(this).closest('.c-slider_item').find('.c-slider-legal').addClass('is-active');
    });
    $('body').on('click','.js-slider-legal__close', function(){
        $(this).parent().removeClass('is-active');
    });

    // Car models slider
    setTimeout(function () {
        const carModelsSwiper = new Swiper('.js-car-models-slider', {
            grabCursor: true,
            speed: 400,
            navigation: {
                nextEl: '.js-car-models-slider-next',
                prevEl: '.js-car-models-slider-prev',
            },
            slidesPerView: 1.15,
            spaceBetween: 20,
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 15
                }
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            }
        });
    }, 15);


    // CTA slider
    // setTimeout(function () {
    //     const ctaSwiper = new Swiper('.js-cta-slider', {
    //         grabCursor: true,
    //         speed: 400,
    //         // navigation: {
    //         //     nextEl: '.js-cta-next',
    //         //     prevEl: '.js-cta-prev',
    //         // },
    //         scrollbar: {
    //             el: '.swiper-scrollbar',
    //         },
    //         slidesPerView: 1.11,
    //         spaceBetween: 10,
    //     });
    // }, 15);


    // Copy to clipboard

    var $copytemp = $("<input>");
    var $copyurl = $(location).attr('href');


    /*$('body').on('click', '.js-show-legal', function () {
        $(this).closest('.c-slider_item').find('.c-slider-legal').addClass('is-active');
    });
    $('body').on('click', '.js-slider-legal__close', function () {
        $(this).parent().removeClass('is-active');
    });*/


    setTimeout(function () {
        $('.js-clipboard').on('click', function () {
            $("body").append($copytemp);
            $copytemp.val($copyurl).select();
            document.execCommand("copy");
            $copytemp.remove();
            $(".js-clipboard-text").text("URL copié dans le Presse-papiers");
            $(".js-clipboard-text").addClass("is-active");
            setTimeout(() => {
                $(".js-clipboard-text").removeClass("is-active");
            }, 1500);
        })
    }, 15);

    window.formFrontPage = createApp({
        data() {
            return {
                types: [
                    { value: 'full', text: 'Inventaire complet' },
                    { value: 'new', text: 'Véhicules neufs' },
                    { value: 'used', text: 'Véhicules d\'occasion' }
                ],
                all: window.makes,
                selectedType: 'full',
                selectedMake: null,
                selectedModel: null
            };
        },
        computed: {
            makes() {
                let makes = [];
                this.all.forEach((make) => {
                    if (this.selectedType === 'full' || make.post_types.split(',').includes(this.selectedType)) {
                        if (!makes.includes(make.make)) makes.push(make.make);
                    }
                });
                makes.sort();
                makes.unshift('Marques');
                return makes;
            },
            models() {
                let models = [];
                this.all.forEach((make) => {
                    if (
                        (make.make == this.selectedMake || this.selectedMake == null) &&
                        (this.selectedType === 'full' || make.post_types.split(',').includes(this.selectedType))
                    ) {
                        if (!models.includes(make.model)) models.push(make.model);
                    }
                });
                models.sort();
                models.unshift('Modèles');
                return models;
            }
        },
        methods: {
            goToInventaire() {
                let url = '/inventaire/';
                if (this.selectedType != 'full') {
                    if (this.selectedType == 'used') {
                        url += '?inventory%5B%5D=used&inventory%5B%5D=demo&inventory%5B%5D=certified';
                    } else {
                        url += '?inventory%5B%5D=' + encodeURIComponent(this.selectedType);
                    }
                }
                if (this.selectedMake) {
                    url += (url == '/inventaire/' ? '?' : '&') + 'makes%5B%5D=' + encodeURIComponent(this.selectedMake);
                }
                if (this.selectedModel) {
                    url += (url == '/inventaire/' ? '?' : '&') + 'models%5B%5D=' + encodeURIComponent(this.selectedModel);
                }
                window.location = url;
            }
        }
    }).mount('.js-form-front-inventaire');

    // If cookie show_chat is not set
    if (readCookie('show_chat') == null) {
        setTimeout(() => {

            const shadowHost = document.querySelector('#lpdg-texto'); // Remplacez par le sélecteur approprié pour l'élément hôte du shadow root
            if (shadowHost && shadowHost.shadowRoot) {
                // Sélectionner le bouton avec l'ID #trigger dans le shadow root
                const triggerButton = shadowHost.shadowRoot.querySelector('#trigger');
                if (triggerButton) {
                    // Émuler un clic sur le bouton
                    triggerButton.click();
                    // console.log('trigger found');

                    // Ajouter la classe .-is-single-active à shadowHost
                    shadowHost.classList.add('-is-single-active');
                    setCookie('show_chat', '1', 1);

                } else {
                    // console.error('Button with ID #trigger not found in shadow root');
                }
            } else {
                // console.error('Shadow host or shadow root not found');
            }

        }, 5000);

    }


}
